"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = exports.parse = void 0;
var tslib_1 = require("tslib");
function parse(str) {
    if (!str) {
        return {};
    }
    return str.split('&').reduce(function (acc, param) {
        var _a = tslib_1.__read(param.split('='), 2), key = _a[0], value = _a[1];
        acc[key] = value;
        return acc;
    }, {});
}
exports.parse = parse;
function stringify(obj) {
    var query = Object.keys(obj)
        .map(function (arg) { return "".concat(arg, "=").concat(obj[arg]); })
        .join('&');
    return query ? "?".concat(query) : query;
}
exports.stringify = stringify;
//# sourceMappingURL=query-string.js.map